import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { Form, FormGroup } from 'reactstrap';
import { Label } from 'reactstrap';
import { Button } from 'reactstrap';
import { FaWhatsapp, FaSearch } from 'react-icons/fa';
import Register from '../Register/Register';
import Resetpass from '../Resetpass/Resetpass';
//import ReactDOM from "react-dom/client";
import axios from 'axios';
import withNavigateHook from '../../myRoutes';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import banner from '../pics/banner.PNG';
import { useNavigate } from 'react-router-dom'
import About from '../About/About';

import { getAllCustomerRegistrations, generateToken, isLoggedIn, getAllActiveCustomerRegistrations } from '../Utils/Utils';
class Login extends React.Component {
    constructor(props) {
        super(props);
        this.handleRegisterOpen = React.createRef();
        this.handleResetPassOpen = React.createRef();
        this.handleAboutOpen = React.createRef();
        this.state = {
            username: '',
            password: '',
            loginStatus: 'Please login!',
            token: "",
            fullname: "",
            allCustomerRegistrations: [],
            userRole: "",
            phonenumber: "",
            address: "",
            emailaddress: "",
            db: "",
            register: "",
            userRole: "",
            msat: "",
            memberstatus: "",
            resetpass: "",
            userid: "",
            registrationdate: "",
        };
    }

    loginText = "";
    componentDidMount = async () => {
      //let  allcust = await getAllCustomerRegistrations();
       // console.log(allcust)
      this.setState({ allCustomerRegistrations: await getAllActiveCustomerRegistrations() });
    }

    authenticate = (e) => {
       // console.log(this.state.allCustomerRegistrations);
        e.preventDefault();
        if(this.state.username === "" || this.state.password === ""){
            this.setState({ loginStatus: "Please fill in all fields!" });
            return;
        }
        const user = this.state.allCustomerRegistrations.find(user => user.emailaddress === this.state.username && user.password === this.state.password &&
            user.status === "Active");
        if (user) {
            var strToken = generateToken();
            localStorage.setItem("token", strToken);
            this.setState({ loginStatus: "Login successful!", token: strToken });            
            this.props.navigate('/home', {
                state: {
                    fullname: user.fullname,
                    emailaddress: user.emailaddress,
                    phonenumber: user.phonenumber,
                    role: user.role, 
                    area: user.area,
                    address: user.address,
                    token: strToken,
                    city: user.city,
                    userid: user.id,
                    gender: user.gender,
                    userstatus: user.status,
                    registrationdate: user.modified,
                }
            });
        } else {
            this.setState({ loginStatus: "Invalid username or password!", password: "" });
            this.loginText = "Invalid username or password!";
        }
    }

    handleUsernameChange = (e) => {
        this.setState({
            username: e.target.value,
        });
    };

    handlePasswordChange = (e) => {
        this.setState({
            password: e.target.value,
        });
    };

    openResetpass = () => {
        this.setState({ resetpass: "resetpass", loginStatus: "Please login!", emailaddress: "", password: "", username: "" });
        this.loginText = "";
        this.handleResetPassOpen.current.handleResetPassOpen();
    }

    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    openRegister = () => {
        this.setState({ register: "register", loginStatus: "Please login!", emailaddress: "", password: "", username: "" });
        this.loginText = "";
        this.handleRegisterOpen.current.handleRegisterOpen();
    }

    onRegisterClose = () => {
        this.setState({ register: "" });
    }
    onResetPassClose = () => {
        this.setState({ resetpass: "", resetemail: "", newpassword: "",loginStatus: "Please login!", emailaddress: "", password: "", username: "" });
        this.loginText = "";
    }

    render() {
        return (
            <>
                <div style={{
                    height: "100vh", margin: "5", padding: "0", paddingLeft: "10px", paddingRight: "10px",
                    justifyContent: "center", alignItems: "center", paddingTop: "1vh", fontFamily:"lora"
                }}>
                    <div
                        style={{
                            paddingTop: "3vh", border: '2px solid white', borderRadius: "10px",
                            backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px', backgroundColor:"darkblue"
                        }}>
                        <div style={{
                            textAlign: "center", fontStyle: "italic", color: "darkblue", fontSize: "25px", fontWeight: "bold", textShadow: "1px 1px 2px white",
                            paddingTop: "30vh "
                        }}>
                            {(() => {
                                if (this.loginText === '') {
                                    return (<label><h3>iWash Laundry  | {this.state.loginStatus}</h3></label>);
                                }
                                if (this.loginText.includes('Invalid username or password!')) {
                                    return (<label style={{ color: "red" }}><h3>{this.state.loginStatus}</h3></label>);
                                }
                            }
                            )()}
                        </div>
                    </div>
                    <div className="login-form" style={{ paddingTop: "10vh" }}>
                        <Form onSubmit={this.authenticate}>
                            <FormGroup>
                                <Input 
                                    id="username"
                                    name="username"
                                    underlinecolor="red"
                                    placeholder="Your e-mail address"
                                    onChange={this.handleUsernameChange}
                                    type="email"
                                    value={this.state.username}
                                    style={{
                                        //backgroundColor:"red",
                                        height: "50px",
                                        borderBottom: "2px solid darkblue",
                                    }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    style={{
                                        //backgroundColor:"red",
                                        height: "50px",
                                        borderBottom: "2px solid darkblue",
                                    }}
                                    id="password"
                                    name="password"
                                    placeholder="Your password"
                                    value={this.state.password}
                                    onChange={this.handlePasswordChange}
                                    type="password"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Button style={{ backgroundColor: "rgb(89, 100, 95)", width: "100%", fontWeight: "bold", color: "white", height: "60px" }}
                                    type="submit">Submit</Button>
                            </FormGroup>
                            <FormGroup>
                                <Button style={{
                                    backgroundColor: "rgb(67, 129, 67)", width: "100%", color: "rgb(208, 247, 228)", border: "none", fontWeight: "bold",
                                    color: "white", height: "60px"
                                }} text="Register" onClick={() => this.openRegister()}>Register here</Button>
                            </FormGroup>
                            <FormGroup>
                                <Button style={{
                                    backgroundColor: "rgb(233, 230, 240)", width: "100%", border: "none", fontWeight: "bold",
                                    color: "rgb(89, 100, 95)", height: "60px"
                                }} text="Reset passsword" onClick={() => this.openResetpass()}>Reset your password</Button>
                            </FormGroup>
                            <div>
                                <Register
                                    ref={this.handleRegisterOpen}
                                    onRegisterClose={this.onRegisterClose}
                                />
                                <Resetpass
                                    ref={this.handleResetPassOpen}
                                    onResetPassClose={this.onResetPassClose}
                                />
                                <About
                                    ref={this.handleAboutOpen}
                                    onAboutClose={this.onAboutClose}
                                />
                            </div>
                        </Form>
                    </div>
                    <div className="footer-content" style={{
                        paddingTop: "10%", marginTop: "auto", padding: "10px", borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666",
                        backgroundColor: "#f0eee4", position: "fixed", bottom: "0", width: "100%"
                    }}>
                        <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                        <div className="footer-links">
                            <Button style={{
                                backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                fontWeight: "bold", textDecoration: "underline"
                            }}
                                onClick={this.openAbout}>About Us
                            </Button>
                            | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withNavigateHook(Login);
